import httpClient from './http-client';
import mockFragmentService from './fragment.service.mock';

let fragmentService;

if (process.env.NODE_ENV === 'development') {
  fragmentService = mockFragmentService;
} else {
  fragmentService = {
    getHeader() {
      return httpClient.get('/fragment/getHeader');
    },

    getFooter() {
      return httpClient.get('/fragment/getFooter');
    },

    getFragments() {
      return httpClient.get('/fragment/getFragment');
    },

    getMenu() {
      return httpClient.get('/fragment/getMenu');
    },

    getProfile() {
      return httpClient.get('/fragment/getProfile');
    },

    getUnreadMessageCount() {
      return httpClient.get('/fragment/getProfileUnreadMessages');
    },
  };
}

export default fragmentService;
